import { MemberColumnInfo, ColumnType } from './validated-data';

export const MEMBERS_FILE_STRUCTURE: MemberColumnInfo[] = [
  {
    columnName: 'Apellido Paterno',
    cell: 'A1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Apellido Materno',
    cell: 'B1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Nombres',
    cell: 'C1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'RFC',
    cell: 'D1',
    type: ColumnType.RFC,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Correo Electronico',
    cell: 'E1',
    type: ColumnType.EMAIL,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Telefono',
    cell: 'F1',
    type: ColumnType.PHONE,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Producto',
    cell: 'G1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Pago',
    cell: 'H1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: true,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'Estado del Registro',
    cell: 'I1',
    type: ColumnType.TEXT,
    isVisible: true,
    isRequiredInFile: false,
  } as unknown as MemberColumnInfo,
  {
    columnName: 'ID',
    cell: 'J1',
    type: ColumnType.TEXT,
    isVisible: false,
    isRequiredInFile: false,
  } as unknown as MemberColumnInfo,
];

export enum MEMBER_COLUMNS_POSITION {
  LAST_NAME = 0,
  LAST_NAME_MOTHER = 1,
  FIRST_NAME = 2,
  RFC = 3,
  EMAIL = 4,
  PHONE = 5,
  PRODUCT = 6,
  PAYMENT = 7,
  STATUS = 8,
  ID = 9,
}
